import { Configuration, LogLevel, PublicClientApplication } from "@azure/msal-browser";

export const b2cPolicies = {
    authorities: {
        signIn: {
            authority: process.env.REACT_APP_AZURE_B2C_AUTHORITY!,
        },
        passwordReset: {
            authority: process.env.REACT_APP_AZURE_B2C_PASSWORD_RESET_AUTHORITY!,
        },
    },
    authorityDomain: process.env.REACT_APP_AZURE_B2C_KNOWN_AUTHORITIES!,
};

export const msalConfig: Configuration = {
    auth: {
        clientId: process.env.REACT_APP_AZURE_B2C_CLIENT_ID!,
        authority: b2cPolicies.authorities.signIn.authority,
        knownAuthorities: [b2cPolicies.authorityDomain],
        redirectUri: process.env.REACT_APP_URI,
        postLogoutRedirectUri: process.env.REACT_APP_URI,
    },
    cache: {
        cacheLocation: "sessionStorage",
        storeAuthStateInCookie: false,
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        break;
                    case LogLevel.Info:
                        console.info(message);
                        break;
                    case LogLevel.Verbose:
                        console.debug(message);
                        break;
                    case LogLevel.Warning:
                        console.warn(message);
                        break;
                }
            },
        },
    },
};

export const loginRequest = {
    scopes: [
        process.env.REACT_APP_AZURE_B2C_OPENID_SCOPE!,
        process.env.REACT_APP_AZURE_B2C_PROFILE_SCOPE!,
        process.env.REACT_APP_AZURE_B2C_API_SCOPE!
    ],
};

export const tokenRequest = {
    scopes: [
        process.env.REACT_APP_AZURE_B2C_API_SCOPE!
    ],
};

export const initializeMSAL = async () => {
    const msalInstance = new PublicClientApplication(msalConfig);
    
    await msalInstance.initialize();
    
    await msalInstance.handleRedirectPromise().then((response) => {
        if (response) {
          msalInstance.setActiveAccount(response.account);
        } else {
          const currentAccounts = msalInstance.getAllAccounts();
          if (currentAccounts.length > 0) {
            msalInstance.setActiveAccount(currentAccounts[0]);
          }
        }
      })
      .catch((error) => {
        console.error('MSAL redirect error:', error);
      });
    
    return msalInstance;
  };